const defaultState = () => ({
  breadcrumbs: [],
});

const mutations = {
  SET(state, breadcrumbs) {
    Object.assign(state, { breadcrumbs });
  },
};

const actions = {
  setBreadcrumbs({ commit }, breadcrumbs) {
    commit('SET', breadcrumbs);
  },
};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  mutations,
};
